import { Component, OnInit } from '@angular/core';
import { NewAssetWizardService } from 'src/app/services/new-asset-wizard.service';

@Component({
  selector: 'app-new-asset-description',
  templateUrl: './new-asset-description.component.html',
  styleUrls: ['./new-asset-description.component.scss'],
})
export class NewAssetDescriptionComponent implements OnInit {

  constructor(
    private assetWizardService: NewAssetWizardService
  ) { }

  ngOnInit() { }

  getCurrentAsset() {
    return this.assetWizardService.getCurrentAssetFromList();
  }

  getUrl() {
    return "assets/vr.gif" //"assets/content/asset-gifs/" + this.getCurrentAsset().name + ".gif";
  }
}
